// The agents' emblems (users, 23 Oct 2026: "more color… agents can have custom images and avatars"). Each person picks how ECONIC's agents
// look: the Icon tile of 12 Oct or an Emblem (a plain shape in the agent's colour carrying its emblem, which moves while the agent works).
// Animal mascots, then the characters' eyes, were tried and dropped on 24 Oct: "much more ministerial and not childish". WP-THEME.

/** How the agents are drawn. `icon` is today's tile (the app keeps its markup); `emblem` the agent's own shape and emblem. */
export type FaceStyle = "icon" | "emblem";
export const FACE_STYLES: readonly FaceStyle[] = ["icon", "emblem"];
export const isFaceStyle = (v: unknown): v is FaceStyle => v === "icon" || v === "emblem";

/** What the agent is doing, read from the conversation (assistant-sdk presence): each state is a still pose; motion only adds to it. */
export type FaceState = "idle" | "listening" | "thinking" | "working" | "speaking" | "done" | "asking" | "error";
export const FACE_STATES: readonly FaceState[] = ["idle", "listening", "thinking", "working", "speaking", "done", "asking", "error"];

/** Level of detail by size: s ≤ 24 px (still, the emblem a little larger), m ≤ 48 px and l (the emblem moves while the agent works). */
export type FaceLod = "s" | "m" | "l";
export const lodOf = (px: number): FaceLod => (px <= 24 ? "s" : px <= 48 ? "m" : "l");

/** The emblems' shapes (one 48 × 48 drawing each). */
export type BodyShape = "orb" | "squircle" | "tall" | "pebble" | "pediment" | "hex" | "dome";
/** The drawn emblems of ECONIC's own agents; generated faces wear their Lucide glyph instead. */
export type EmblemId = "ribbon" | "book" | "bars" | "globe" | "landmark" | "trend" | "radar";

export interface DrawnFace {
  body: BodyShape;
  emblem: EmblemId;
}

export interface GeneratedFace {
  body: BodyShape;
  /** A hue angle (OKLCH) for the looks that colour generated faces (Signature, Aurora); Classic draws them in the navy tile. */
  hue: number;
}
